function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M753 1175 c-136 -37 -225 -113 -258 -219 -9 -28 -28 -77 -42 -108 l-27 -58 22 -23 c33 -35 27 -58 -33 -124 -69 -77 -71 -99 -10 -114 50 -13 50 -12 33 -38 -10 -17 -8 -23 11 -38 20 -16 22 -23 12 -40 -9 -17 -8 -25 4 -36 8 -9 13 -31 12 -57 -1 -31 4 -46 18 -56 21 -16 81 -18 138 -5 l38 9 24 -49 25 -49 250 0 c271 0 267 -1 230 55 -77 113 -77 245 1 366 62 95 74 133 74 229 0 76 -4 93 -33 152 -81 164 -298 254 -489 203z m281 -63 c122 -57 191 -147 203 -267 8 -74 -12 -143 -63 -223 -79 -123 -92 -244 -39 -359 l24 -53 -207 0 -207 0 -28 51 c-27 49 -28 50 -65 42 -20 -4 -59 -8 -86 -8 l-49 0 -1 76 c-1 57 -5 82 -18 96 -11 12 -14 23 -8 33 14 23 -7 48 -51 60 l-41 11 56 59 c61 64 72 103 40 148 -15 21 -14 27 4 70 11 26 25 65 31 88 15 58 48 102 105 141 117 80 274 94 400 35z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91 668 c-66 -88 -85 -147 -85 -263 0 -79 5 -111 22 -155 25 -63 91 -155 112 -155 26 0 20 20 -20 74 -104 139 -104 331 1 470 37 49 45 81 20 81 -6 0 -28 -24 -50 -52z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196 587 c-65 -85 -78 -216 -32 -310 31 -64 59 -92 82 -83 15 6 15 8 0 29 -43 58 -56 85 -66 132 -14 69 2 140 45 201 19 26 32 51 29 56 -11 17 -34 7 -58 -25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M307 512 c-22 -24 -37 -67 -37 -108 0 -65 47 -141 72 -116 7 7 4 21 -12 47 -26 43 -24 113 5 145 17 19 15 50 -3 50 -5 0 -16 -8 -25 -18z"
}));

const SvgSpeaking = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "128.000000pt",
  height: "128.000000pt",
  viewBox: "0 0 128.000000 128.000000",
  preserveAspectRatio: "xMidYMid meet",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpeaking, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Speaking.34716ae9.svg";
export { ForwardRef as ReactComponent };